import React, { useState } from 'react';
import Select from 'react-select';
import { Table } from "antd";

const OtherChargesTab = () => {
    const columns = [
        { title: "Charge Head", dataIndex: "chargeHead", key: "chargeHead" },
        { title: "Basis", dataIndex: "basis", key: "basis" },
        { title: "Charge Type", dataIndex: "chargeType", key: "chargeType" },
        { title: "Override", dataIndex: "override", key: "override" },
        { title: "Due To", dataIndex: "dueTo", key: "dueTo" },
        { title: "Curr", dataIndex: "curr", key: "curr" },
        { title: "Rate", dataIndex: "rate", key: "rate" },
      ];
      

const dataSource = [
{
key: "", // Add a unique key for each row
SNo: "", // Changed to camelCase

},
]

return (
<>
    <div className="row border-bottom-2 card m-1">
        <div className="col-md-12 card-body">
        
            
            <div className="table-responsive custom-table">
                <Table className="table datanew dataTable no-footer" pagination={false} dataSource={dataSource}
                    columns={columns} />
            </div>
            {/* <div className="row mt-2">
            <div className="col-md-4">
                    <div className=' '>
                        <label htmlFor="" className='form-label  mb-0'>
                           HCNote No.
                        </label>
                        <div className="icon-forms mb-3 mb-sm-0">
                            <input type="text" className="form-control form-control-sm" name='search_by' />
                        </div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className=' '>
                        <label htmlFor="" className='form-label  mb-0'>
                            Current Status
                        </label>
                        <div className="icon-forms mb-3 mb-sm-0">
                            <input type="text" className="form-control form-control-sm" name='search_by' />
                        </div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className=' '>
                        <label htmlFor="" className='form-label  mb-0'>
                            New Status
                        </label>
                        <div className="icon-forms mb-3 mb-sm-0">
                            <Select className='custom-selector ' name="role_id" />
                        </div>
                    </div>
                </div>

                <div className="col-md-6">
                    <div className=' '>
                        <label htmlFor="" className='form-label  mb-0'>
                            Date
                        </label>
                        <div className="icon-forms mb-3 mb-sm-0">
                            <input type="date" className="form-control form-control-sm" name='search_by' />
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className=' '>
                        <label htmlFor="" className='form-label  mb-0'>
                            Remark
                        </label>
                        <div className="icon-forms mb-3 mb-sm-0">
                            <input type="text" className="form-control form-control-sm" name='search_by' />
                        </div>
                    </div>
                </div>
            </div> */}

            <div className="d-flex flex-wrap gap-2 mt-2 pb-2" style={{ borderBottom: '1px solid #d4d4d4' }}>
                <button className="btn btn-primary text-xs" type="button">
                    New
                </button>
                <button className="btn btn-primary text-xs" type="button">
                    Edit
                </button>
                <button className="btn btn-primary text-xs" type="button">
                    Cancel
                </button>
             
            </div>
        </div>
    </div>

</>
);
};

export default OtherChargesTab